import React from "react";
import { DotLegalSelect } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation.ts";
import { ReceiptChannel } from "../../../incidentLog/IncidentLogDialog.types.ts";
import { getReceiptChannelSelectOptions } from "../../../incidentLog/incidentLogDialog/CreateEditIncidentLogDialog.hooks.ts";

export interface IncidentLogReceiptChannelFieldProps {
    receiptChannel?: ReceiptChannel | null;
    onChange: (receiptChannel: ReceiptChannel | null) => void;
    disabled: boolean;
    errorText?: string;
}

function IncidentLogReceiptChannelField(props: IncidentLogReceiptChannelFieldProps) {
    const { translateString } = useTranslation();

    return (
        <DotLegalSelect
            options={getReceiptChannelSelectOptions(translateString)}
            selectedItem={props.receiptChannel ? props.receiptChannel.toString() : null}
            onChange={(receiptChannel) => props.onChange(receiptChannel ? (Number(receiptChannel) as ReceiptChannel) : null)}
            label={translateString("receiptChannel")}
            noOptionsLabel={translateString("noOptions")}
            disabled={props.disabled}
            errorText={props.errorText}
        />
    );
}

export default IncidentLogReceiptChannelField;
